<template>
    <div class="container" v-if="flag">
       <img src="../assets/images/组 8462@2x.png" alt="" class="cho_title">
       <img src="../assets/images/组 8458@2x.png" alt="" class="right_top">
        <div class="mainlist">
            <div class="options">
                    <div class="type" v-for="(item) in list1" :key="item.index" @click="change(item.index)">
                        <span class="outer_circle">
                            <span class="word">{{item.name.substring(0, item.name.length - 1)}}倾向 >>></span>
                        </span>
                    </div>
            </div>
            <div class="options">
                    <div class="type" v-for="item in list2" :key="item.index" @click="change(item.index)">
                        <span class="outer_circle">
                            <span class="word">{{item.name.substring(0, item.name.length - 1)}}倾向 >>></span>
                        </span>
                    </div>
            </div>
            <div class="options">
                    <div class="type" v-for="item in list3" :key="item.index" @click="change(item.index)">
                        <span class="outer_circle">
                            <span class="word">{{item.name.substring(0, item.name.length - 1)}}倾向 >>></span>
                        </span>
                    </div>
            </div>
        </div>
    </div>
</template>
<script>
import Router from 'vue-router'
export default {
   data() {
      return {
        flag: true,
        list1:[], //展示列表
        list2:[], //展示列表
        list3:[], //展示列表
        domainId:'',
        unionId:'',
        candidateId:'',
        changeColor:false
      }
    },
    created() {
        this.URl();
    },
    methods:{
        // 获取url参数
        URl(){
            var quizUrl = decodeURIComponent(location.hash);
            var request=quizUrl.split("/")[2]; //字符分割
            console.log(request)
            if(request !== undefined){
                this.unionId = request.split("=")[1]
                this.getList();
            }
        },
        getList(){
            document.title = '人才素质测评报告'
            this.list1 = [
                {index:20,name:'市场类'},
                {index:40,name:'生产类'},
                {index:170,name:'品控类'},
                {index:150,name:'法务类'},
                {index:100,name:'行政类'},
                {index:140,name:'外贸类'}
            ]
            this.list2 = [
                {index:30,name:'销售类'},
                {index:50,name:'设计类'},
                {index:80,name:'采购类'},
                {index:90,name:'财务类'},
                {index:110,name:'客服类'},
                {index:60,name:'IT技术类'},
            ]
            this.list3 = [
                {index:40,name:'生产类'},
                {index:70,name:'工程技术类'},
                {index:130,name:'人力资源类'},
                {index:160,name:'语言翻译类'},
                {index:180,name:'管理培训生类'},
            ]
        },
        // 点击
        change(index){
            this.$router.push({name:'standard',params:{domainId:index,unionId:this.unionId}});
        }
    }
}
</script>
<style>
    div,img{
        padding: 0;
        margin: 0
    }
    .container{
        width: 100%;
        height: 100%;
    }
    .cho_title{
        float: left;
        width: 100%;
        width: 100%;
    }
    .right_top{
        position: absolute;
        width: 30%;
        top: 0;
        right: 0;
        z-index: 1
    }
    .mainlist{
        width: 100%;
        padding-top: 24px;
        overflow-x: scroll;
        overflow-y: hidden;
        white-space: nowrap;
    }
    .options{
        vertical-align: top;
        padding-top: 20px;
        padding-bottom: 20px;
        padding-left: 20px;
        overflow-x: scroll;
        overflow-y: hidden;
        white-space: nowrap;
        display: inline-block
    }
    .options:first-child{
        padding-left: 18px;
    }
    .options:nth-child(2){
        padding-left: 30px;
    }
    .options:nth-child(3){
        padding-left: 15px;
    }
    .type{
        margin-top: 44px
    }
    .type:first-child{
        margin-top: 0
    }
    .outer_circle{
        border: 1px solid #000;
        border-radius:10px;
        padding: 12px 0;
    }
    .word{
        position: relative;
        left: -6px;
        top: -6px;
        font-family:Source Han Sans CN;
        font-size: 16px;
        font-size: 400;
        line-height: 27px;
        padding: 12px 16px;
        border: 1px solid #000;
        border-radius:10px; 
        opacity: 1;
        background-color: #fff;
    }
    .options:first-child .type:nth-child(2n+1) .outer_circle .word{
        color: #fff;
        background-color: #1AB394
    }
    .options:nth-child(2) .type:nth-child(2n) .outer_circle .word{
        color: #fff;
        background-color: #1AB394
    }
    .options:nth-child(3){
        padding-right: 12px;
    }
    .options:nth-child(3) .type:nth-child(2n+1) .outer_circle .word{
        color: #fff;
        background-color: #1AB394
    }
    ::-webkit-scrollbar {
        width: 0px;
    }
</style>